import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PieChartFilledSvg from "@ant-design/icons-svg/es/asn/PieChartFilled";
import AntdIcon from "../components/AntdIcon";
var PieChartFilled = function PieChartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PieChartFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PieChartFilled.displayName = 'PieChartFilled';
}
export default /*#__PURE__*/React.forwardRef(PieChartFilled);